// extracted by mini-css-extract-plugin
export var infoRow = "_p6-2";
export var labelContainer = "_p6-0";
export var rightInfo = "_p6-1";